import type {
  AuctionParticipant, AuctionParticipantContact,
  ConsentInfo,
  ConsentTypesEnum,
  ConsentOutput,
  ContactGeneralInfo,
  Contact,
} from '@apiTypes'

export function isConsentGained(consent: ConsentOutput, type: ConsentTypesEnum): boolean {
  return isConsentGainedForStatuses(consent.consentStatuses, type)
}

function isConsentGainedForStatuses(consentStatuses: ConsentInfo[], type: ConsentTypesEnum): boolean {
  return consentStatuses.some(status => status.consentType === type && status.isGained)
}

export function isConsentGainedForParticipant(participant: AuctionParticipant, type: ConsentTypesEnum): boolean {
  return participant.contacts.some(contact => isConsentGainedForContact(contact, type))
}

export function isConsentGainedForContact(contact: Contact | ContactGeneralInfo | AuctionParticipantContact, type: ConsentTypesEnum): boolean {
  return isConsentGainedForStatuses(contact.consentStatuses || [], type)
}
